import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { ApiService } from "../../components/Common/ApiService";
import { isPending } from '../../store/actions/todoActions';

import { useDispatch } from "react-redux";
import { ReactComponent as UsernameIcon } from "../../assets/icon/gg_profile.svg";
import { ReactComponent as Logolight } from "../../assets/logo_light.svg";
import Button from "../../components/Common/Button";
import Input from "../../components/Common/Input";
import { useHandleClickLoading } from "../../components/Common/utils";
import MobileAccessBanner from "../Hompages/MobileAccessBanner";

function ForgotPasswordPages() {
  const isWebSetting = localStorage.getItem('isWebSetting');
  const parseWebSetting = JSON.parse(isWebSetting);
  const [username, setUsername] = useState("");
  const dispatch = useDispatch();
  const handleClickLoading = useHandleClickLoading();

  const fetchForgot = async (username) => {
    dispatch(isPending(true));
    try {
      const params = new URLSearchParams();
      params.append("nomor", username);

      const response = await ApiService({
        baseurl: "user/forgot",
        XGORDON: "FORGOT",
        method: "POST",
        body: params,
      });
      dispatch(isPending(false));
      if (response?.statusCode === 200) {
        toast.success(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleForgot = (username) => {
    const phoneRegex = /^\+62\d{8,17}$/;
    if (!phoneRegex.test(username)) {
      toast.error("Nomor telepon tidak valid. Mohon periksa masukan Anda.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    // Jika semua input valid, lanjutkan dengan proses login
    fetchForgot(username);
  };

  return (
    <div className="flex flex-col gap-3 flex-1 relatve">
      <div className="fixed top-0 left-0 bottom-0 right-0 bg-gradient-to-br from-[#FFB6FF] to-[#B9BDFF] " />
      <div className="flex flex-col gap-2 flex-1">
        <MobileAccessBanner />
        <div className="flex flex-row h-full  rounded-none gap-2 z-1">
          <div className="flex flex-col flex-1 bg-cardLight dark:bg-cardDark lg:rounded-xl shadow-inner">
            <div className="flex flex-col p-4 gap-2 items-center">
            <button onClick={() => handleClickLoading('/')}>
                <Logolight className=" h-14 w-52" />
              </button>
              <span
                className={`text-lg font-medium text-center`}
              >
                Selamat datang di <b className="text-[#22BDE2]">{parseWebSetting?.judul}</b>
              </span>
              <span
                className={`text-sm text-center line-clamp-2`}
              >
                {parseWebSetting?.deskripsi_footer}
              </span>
              <img
                src={require("../../assets/images/dsawfg 1.png")}
                alt={"item.gambar"}
                className=" object-contain w-full h-full max-h-56 "
                effect="blur"
              />
              <span
                className={` text-base font-medium text-center`}
              >
                Lupa Password
              </span>
              <span
                className={` text-sm text-center`}
              >
                Masukan 6 Digit Kode Verifikasi yang dikirim ke Email Anda
              </span>
              <div className="flex flex-col gap-3 w-full">
                <Input
                  label="Nomor Whatsapp"
                  id="phone"
                  icon={<UsernameIcon />}
                  value={username}
                  type="tel"
                  placeholder={"Masukan Nomor Whatsapp"}
                  onChange={(event) => setUsername(event)}
                />
                <Button
                  initialValue="Lupa Password"
                  type="fill"
                  className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  text-darkColor"
                  onClick={() => {
                    handleForgot(username,);
                  }}
                />
                <Button
                  initialValue="Ke Halaman Login"
                  type="fill"
                  className=" text-[#22BDE2]"
                  onClick={() => {
                    handleClickLoading("/login");
                  }}
                />
              </div>
            </div>
          </div>
          <div className="hidden sm:flex md:hidden flex-col p-5 bg-[#22BDE2] rounded-tl-none rounded-bl-none" />
          <div className="hidden md:flex flex-col flex-1 bg-[#22BDE2] lg:rounded-xl rounded-tl-none rounded-bl-none">
          <img
              src={require('../../assets/images/pngwing 6.png')}
              alt="Logo"
              className="object-cover flex-1 h-full w-full " />
          </div>
        </div>
      </div>

    </div>
  );
}

export default ForgotPasswordPages;
